import React from 'react';

import {FIND_ALL_PERGUNTAS as query} from '../../../graphql/queries';
import {SelectBase} from './select-apollo';

const getVariables = ({pageNumber, search = '', pageSize = 20}) => {
  return {
    pageableDTO: {pageNumber, pageSize, sortField: 'pergunta', sortDir: 'ASC'},
    searchDTO: {search},
  };
};

export const SelectAnamnesePerguntas = (props) => {
  return (
    <SelectBase
      responseObjectName="perguntas"
      labelProp="pergunta"
      query={query}
      getVariables={getVariables}
      {...props}
    />
  );
};
